import React from "react";
import styles from "./ExperienceItem.module.css";

function ExperienceItem(props: any) {
  let experienceItem = props.experienceItem;

  let key =
    experienceItem.key ||
    experienceItem.title.replace(/\s+/g, "-").toLowerCase();

  return (
    <div className={styles.ExperienceItem} key={key}>
      <div className={styles.jobHeader}>
        <div>
          <span className={styles.title}>{experienceItem.title}</span>,
          <span> {experienceItem.company}</span> —
          <span> {experienceItem.location}</span>
        </div>
        <div className={styles.workedDates}>
          <span>{experienceItem.dateStart}</span> —{" "}
          <span>{experienceItem.dateEnd}</span>
        </div>
      </div>

      <div className={styles.infoWrapper}>
        <div>
          <p>{experienceItem.jobDescription}</p>
        </div>
        {experienceItem.keyAchievements &&
          experienceItem.keyAchievements.length > 0 && (
            <div className={styles.keyAchievements}>
              <h2>Key Achievements:</h2>
              <ul>
                {experienceItem.keyAchievements.map(
                  (achievement: any, index: number) => {
                    if (typeof achievement === "object") {
                      return (
                        <li key={index}>
                          {achievement.description}
                          <ul>
                            {achievement.subpoints.map(
                              (subpoint: string, index: number) => {
                                return <li key={index}>{subpoint}</li>;
                              },
                            )}
                          </ul>
                        </li>
                      );
                    } else {
                      return <li key={index}>{achievement}</li>;
                    }
                  },
                )}
              </ul>
            </div>
          )}
      </div>
    </div>
  );
}

export default ExperienceItem;
